import { mapGetters } from "vuex"

import is_project_tab_section from "./IsProjectTabSection"

const is_project_relation_tab_section = {
    mixins: [is_project_tab_section],
    mounted () {
        this.load()
    },
    watch: {
        $route: "load",
        profile_id: "load",
        record: "load"
    },
    methods: {
        load () {
            if(this.profile_id && !!this.record && this.record.id) {
                this.loading = true
                const query = this.augment_query({
                    project_id: this.record.id,
                    fields: ["fieldset::default"],
                    relation_ids: this.relation_ids
                })
                this.$store.dispatch(
                    "FETCH_RECORDS",
                    {
                        entity: this.entity,
                        query
                    }
                ).then(() => {
                }).catch(error => {
                    this.$error(error.message)
                }).then(() => {
                    this.loading = false
                })
            }
        },
        augment_query (query) {
            return query
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_records () {
            return this.$store.getters.entity_records(this.entity)
        }
    },
    data () {
        return {
            loading: false,
            relation_ids: []
        }
    }
}

export default is_project_relation_tab_section
